<div class="switch-container">
    <div class="switch-content">
      <h1 class="switch-title">
        {{orgName ? 'Switching to ' + orgName : 'Switching Organization'}}
      </h1>
      <div class="loader"></div>
      <p class="switch-message">
        Please wait while we prepare your workspace
      </p>
    </div>
  </div>